const isValidCallbackText = ({ block }: any) => {
    const {
        data: { v2_rich_text },
    } = block;
    return {
        isValid: Boolean(v2_rich_text.trim()),
        error: (
            // <Alert
            //     message="Validation Error"
            //     description={`Text cannot be empty`}
            //     type="error"
            //     showIcon
            // />
            <></>
        ),
    };
};

export default isValidCallbackText;
